import React from 'react';
import { Col, Row } from '../../core/components/layout-utils';
import scrollTo from "scroll-to-element"  

class MineralEmbedded extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInsightEventsAPI: false,
      showInsightDetailsAPI: false  

    };
 
  }

  
componentDidMount() {  
  const hash = window.location.hash;  
  if (hash === "#/mineralEmbedded") {  
    // Wait for DOM to be ready  
    setTimeout(() => {  
      scrollTo('#mineralEmbedded', {  
        offset: -5  // Use the same offset as sidebar  
      });  
    }, 100);  
      
    this.setState({ showMineralEmbedded: true });  
  }  
}

  
  toggleMineralEmbedded = () => {
    this.setState({ showMineralEmbedded: !this.state.showMineralEmbedded });
  };

  toggleInsightEventsAPI = () => {
    this.setState({ showInsightEventsAPI: !this.state.showInsightEventsAPI });
  };

  toggleInsightDetailsAPI = () => {
    this.setState({ showInsightDetailsAPI: !this.state.showInsightDetailsAPI });
  };

  toogleAPIErrorCode=() =>{
    this.setState({ showAPIErrorCodes: !this.state.showAPIErrorCodes });
  }

  toogleshowAPIAccess=() =>{
    this.setState({ showAPIAccess: !this.state.showAPIAccess });
  }

  showEmbeddedWebhookSection=() =>{
    this.setState({showEmbeddedWebhookSection :!this.state.showEmbeddedWebhookSection})
  }

  render() {
    const { getComponent } = this.props;
    const Collapse = getComponent ? getComponent("Collapse") : null;

    const { isCollapsed } = this.state;
    return (
      <span>
      <div className="opblock-tag-section" id="mineralEmbedded">
        <h4 className="opblock-tag">
          
          
          <a className="nostyle" href="#mineralEmbedded">
            <span>Embedded Compliance<br />Intelligence Insights</span>
          </a>
          <small>
            <div className="renderedMarkdown">
            <p style={{ color: 'black', textAlign: 'justify' }}>
              Embedded Compliance Intelligence Insights allows partners to seamlessly integrate Mineral Intelligence directly into their own platforms through a robust API offering. With access to embedded Insight Events, detailed insight data, and real-time webhook notifications, developers can surface compliance signals, action items, and HR intelligence within their native user experiences.
              <br />
              This guide provides all the technical resources and specifications needed to get started, including authentication flows, API usage patterns, filtering options, and webhook setup. You’ll also find instructions for how to engage the Mineral Integration team for implementation support and coordination.
            </p> 
            </div>
          </small>
          <div></div>
            <button
              className="expand-operation"
              title={isCollapsed ? "Expand operation" : "Collapse operation"}
              onClick={this.toggleMineralEmbedded}
              aria-expanded={!isCollapsed}
              aria-controls="mineral-content"
            >
        <i
            className="material-icons pull-right"
            style={{ fontSize: '20px', cursor: 'pointer' }}
        >
            {this.state.showMineralEmbedded
            ? 'keyboard_arrow_down'
            : 'keyboard_arrow_right'}
        </i> 
            </button>

          
        </h4>
        
        {/* <div style="height: auto; border: none; margin: 0px; padding: 0px;">
          <div class="metadata-table">
          <table class="metadata-table"><tr><th>Name</th><th>Type</th><th>Required</th><th>Can be used for Filtering</th><th>Description</th></tr><tr><td>companyName</td><td>String</td><td>Yes</td><td>Yes</td><td>Company Name must only use capital and lower case letters A-Z, numerals 0-9, and only the following symbols and punctuation: ! " " # $ &amp; ' () * + ,- . ? / : @ { } [ ] ~_^ ` |.</td></tr><tr><td>displayName</td><td>String</td><td>Yes</td><td>Yes</td><td>Display Name of the company (ex: ACME). This can be the same as the companyName, but it can be used as a shorter or nonlegal display name.</td></tr><tr><td>industry</td><td>String</td><td>Yes</td><td>Yes</td><td>The industry the company is in. Can only take one of the following possible values: All, Accounting, Agriculture, Banking, Construction, Consulting, Corporate, Credit Union, Distribution, Drug and Cosmetic, Education, Entertainment, Financial Services, Food Service, Guide, HR Consultant, Health and Wellness, Healthcare, Hospitality, Insurance, Lost Client, Manufacturing, Media, My Industry is not here, Networking, Non-Profit, Oil and Gas, Payroll, Private Security, Professional Services, Publishing, Real Estate, Recruiting/ Staffing, Rental, Restaurants, Retail, Software, Technology, Transportation.</td></tr><tr><td>configurationName</td><td>String</td><td>Yes</td><td>Yes</td><td>The SKU configuration assigned to this company.</td></tr><tr><td>locationName</td><td>String</td><td>Yes</td><td>No</td><td>A descriptive name for the company's primary location (ex: Primary Location).</td></tr><tr><td>phone</td><td>String</td><td>No</td><td>No</td><td>The primary phone line for the location.  The value must be null or in a 10-digit format with up to a 5-digit extension: 123-456-7890 or 123-456-7890 ext. 55555.</td></tr><tr><td>zip</td><td>String</td><td>Yes</td><td>Yes</td><td>The 5-digit zip code of the company's location. Zip would have the highest priority, with valid zip if “state” and “stateCode” is invalid so according to the zip “state” and “stateCode” would be auto-corrected.</td></tr><tr><td>city</td><td>String</td><td>No</td><td>No</td><td>The city where the company is located in.</td></tr><tr><td>county</td><td>String</td><td>No</td><td>No</td><td>The county where the company is located in.</td></tr><tr><td>state</td><td>String</td><td>No</td><td>No</td><td>The state where the company is located in.</td></tr><tr><td>address</td><td>String</td><td>No</td><td>No</td><td>The address of the company.</td></tr><tr><td>address2</td><td>String</td><td>No</td><td>No</td><td>An optional second address line if needed.</td></tr><tr><td>businessType</td><td>Enum</td><td>Yes</td><td>No</td><td>Can only take one of the following possible values: Private, Public, or Nonprofit Organization.</td></tr><tr><td>employeeCount</td><td>Integer</td><td>No</td><td>No</td><td>The employee count at this particular company location.</td></tr><tr><td>industryClassification</td><td>String</td><td>Yes</td><td>No</td><td>Refers to NAICS Code and can only take one of the following possible values: 92 - Public Administration, 81 - Other Services (except Public Administration), 72 - Arts, Entertainment, and Recreation, 62 - Healthcare and Social Assistance, 61 - Educational Services, 56 - Administrative and Support and Waste Management and Remediation Services, 55 - Management of Companies and Enterprises, 54 - Professional, Scientific, and Technical Services, 53 - Real Estate and Rental and Leasing, 52 - Finance and Insurance, 51 - Information, 48-49 - Transportation and Warehousing, 44-45 - Retail Trade, 42 - Wholesale Trade, 31-33 - Manufacturing, 23 - Construction, 22 - Utilities, 21 - Mining, Quarrying, and Oil and Gas Extraction, 11 - Agriculture, Forestry, Fishing and Hunting.</td></tr><tr><td>isFederalContractor</td><td>Boolean</td><td>No</td><td>No</td><td>Is the client a federal contractor at the location? A valid value is either "true"/"TRUE" or "false"/"FALSE". Any other value will be treated as FALSE.</td></tr><tr><td>isHQ</td><td>Boolean</td><td>No</td><td>No</td><td>Is this location a headquarter? A valid value is either "true"/"TRUE" or "false"/"FALSE".</td></tr><tr><td>isUnionized</td><td>Boolean</td><td>No</td><td>No</td><td>Is there a union agreement at the location? The valid value for isUnionized is either "true"/"TRUE" or "false"/"FALSE". Any other value will be treated as FALSE.</td></tr><tr><td>websiteUrl</td><td>String</td><td>No</td><td>Yes</td><td>Company website url.</td></tr><tr><td>producer</td><td>String</td><td>No</td><td>Yes</td><td>Deprecated field used for legacy customers.</td></tr><tr><td>referenceId</td><td>String</td><td>No</td><td>Yes</td><td>An optional reference ID associated with the company.</td></tr><tr><td>federalEIN</td><td>String</td><td>No</td><td>Yes</td><td>The 9-digit Federal Employer Identification Number assigned to the company by the Internal Revenue Service. Use the format XX-XXXXXXX (ex: 99-1122331)</td></tr><tr><td>isActive</td><td>Boolean</td><td>No</td><td>Yes</td><td>Read-only field in the response. Always true for all locations of the company.</td></tr><tr><td>createdBy</td><td>Integer</td><td>No</td><td>Yes</td><td>Read-only field in the response. User ID of who created the company.</td></tr><tr><td>createdOn</td><td>Integer</td><td>No</td><td>Yes</td><td>Read-only field in the response. Time when the company was created.</td></tr><tr><td>modifiedOn</td><td>Integer</td><td>No</td><td>Yes</td><td>Read-only field in the response. Time when the company was modified.</td></tr><tr><td>companyId</td><td>Integer</td><td>No</td><td>Yes</td><td>Read-only field in the response. The ID of the company.</td></tr></table></div>
          <span><div class="opblock opblock-get" id="operations-Companies-get_v2_companies"><span class="method-id" id="Companies-GET-ALL"></span><div class="opblock-summary-description"><div>List Companies<span class="opblock-method">GET</span><i class="material-icons pull-right">keyboard_arrow_down</i></div></div><noscript></noscript></div></span><span><div class="opblock opblock-post" id="operations-Companies-post_v2_companies"><span class="method-id" id="Companies-POST"></span><div class="opblock-summary-description"><div>Create Company<span class="opblock-method">POST</span><i class="material-icons pull-right">keyboard_arrow_down</i></div></div><noscript></noscript></div></span><span><div class="opblock opblock-get" id="operations-Companies-get_v2_companies__companyId_"><span class="method-id" id="Companies-GET-ONE"></span><div class="opblock-summary-description"><div>Fetch Company<span class="opblock-method">GET</span><i class="material-icons pull-right">keyboard_arrow_down</i></div></div><noscript></noscript></div></span><span><div class="opblock opblock-put" id="operations-Companies-put_v2_companies__companyId_"><span class="method-id" id="Companies-PUT"></span><div class="opblock-summary-description"><div>Update Company<span class="opblock-method">PUT</span><i class="material-icons pull-right">keyboard_arrow_down</i></div></div><noscript></noscript></div></span><span><div class="opblock opblock-patch" id="operations-Companies-patch_v2_companies__companyId_"><span class="method-id" id="Companies-PATCH"></span><div class="opblock-summary-description"><div>Deactivate Company<span class="opblock-method">PATCH</span><i class="material-icons pull-right">keyboard_arrow_down</i></div></div><noscript></noscript></div></span><span><div class="opblock opblock-put" id="operations-Companies-put_v2_companies__companyId__users_preferences"><span class="method-id" id="Companies-PUT"></span><div class="opblock-summary-description"><div>Update Company<span class="opblock-method">PUT</span><i class="material-icons pull-right">keyboard_arrow_down</i></div></div><noscript></noscript>
          </div></span></div> */}
        {/* Collapsible Content */}
      
        <div
          style={{
            height: this.state.showMineralEmbedded ? 'auto' : '0px',
            overflow: 'hidden',
            border: 'none',
            margin: '0px',
            padding: this.state.showMineralEmbedded ? '10px' : '0px',
          }}
        >
        <div style={{ 
        backgroundColor: '#fff3cd', 
        borderLeft: '6px solid #ffeeba', 
        padding: '16px', 
        marginTop: '20px', 
        borderRadius: '4px', 
        color: '#856404', 
        fontSize: '14px' 

        }}>
        <strong>🔒 Note:</strong> An <strong>API Key is mandatory </strong>for accessing the Embedded Compliance Intelligence Insights  APIs.  
        Ensure that you include a valid API key in the request headers when calling any Embedded Compliance Intelligence Insights endpoint.             
        </div>
      <div>

        <div style={{ marginTop: '2em' }}>
        <h4 style={{fontSize:'16px',fontWeight: 'bold' }}>API Server URL</h4>
        <table className="table is-bordered" style={{ width: '60%', fontSize: '15px', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
        <thead>
            <tr>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Environment</th>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>URL</th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td style={{ border: '1px solid #ccc', padding: '8px' }}>Production</td>
            <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                <a href="https://restapis.trustmineral.com" target="_blank" rel="noopener noreferrer">
                https://restapis.trustmineral.com
                </a>
            </td>
            </tr>
            <tr>
            <td style={{ border: '1px solid #ccc', padding: '8px' }}>Sandbox</td>
            <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                <a href="https://restapis.alpha01.trustmineral-staging.com" target="_blank" rel="noopener noreferrer">
                https://restapis.alpha01.trustmineral-staging.com
                </a>
            </td>
            </tr>
        </tbody>
        </table>

        </div>        
    </div>      
    <div id="mineral_embedded1" className={this.state.showInsightEventsAPI ? "opblock-summary-description is-open" : "opblock-summary-description"}  style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
          {/* <h6 onClick={this.toggleInsightEventsAPI} className="opblock-summary-description" style={{ cursor: 'pointer' }}> */}
    <div  onClick={this.toggleInsightEventsAPI} class="opblock-summary-description">
    <div  style={{fontSize: '16px', scrollMarginTop: '80px',fontWeight:'bold'}}>
      Company Insights (GET)
    <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
      {this.state.showInsightEventsAPI ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
    </i>        
    </div>

    </div>
  {/* </h6> */}
  {Collapse && (
    <Collapse isOpened={this.state.showInsightEventsAPI}>
      <div className="opblock-body" style={{ paddingTop: '10px' }}>
        {/* Base URL section */}
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '35px' , marginBottom: '10px' }}>
          <h4 style={{ fontSize:'16px',fontWeight: 'bold', margin: 0, marginRight: '10px' }}>API Call:</h4>
          <code
            style={{
              backgroundColor: '#f5f5f5',
              color: '#000',
              padding: '8px',
              borderRadius: '4px',
              fontFamily: 'Consolas, monospace',
              fontSize: '14px',
              border: '1px solid #ccc',
              whiteSpace: 'nowrap', // Prevent text wrapping
              overflow: 'hidden',  // Hide overflow content
              textOverflow: 'ellipsis', // Show ellipsis when text overflows
              width: 'auto', // Adjust the width to prevent excessive expansion
              marginRight: '20px',
            }}
          >
            /v2/mintel/{'{companyId}'}/insight-events
          </code>
        </div>
        <p style={{ marginBottom: '15px' }}>Returns a list of Insight Events for a given company.</p>
        <h4 style={{ fontSize:'16px',fontWeight: 'bold', marginTop: '35px'}}>Supported API Parameters</h4>
        <table className="parameters" style={{ borderCollapse: 'collapse', width: '100%', marginTop: '25px' }}>
          <thead>
            <tr style={{ backgroundColor: '#e0e0e0', color: 'black', fontWeight: 'bold', textAlign: 'left' }}>
              <th style={tableHeaderStyle}>Name</th>
              <th style={tableHeaderStyle}>Type</th>
              <th style={tableHeaderStyle}>Required</th>
              <th style={tableHeaderStyle}>Can be used for Filtering</th>
              <th style={tableHeaderStyle}>Description</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, i) => (
              <tr key={i} style={i % 2 === 0 ? {} : { backgroundColor: '#f9f9f9' }}>
                <td style={tdStyle}>{row.name}</td>
                <td style={tdStyle}>{row.type}</td>
                <td style={tdStyle}>{row.required}</td>
                <td style={tdStyle}>{row.filterable}</td>
                <td style={tdStyle} dangerouslySetInnerHTML={{ __html: row.description }} />
              </tr>
            ))}
          </tbody>
        </table>
        <h4 style={{ fontSize:'16px',fontWeight: 'bold'}}>Required Path Parameter</h4>
        <ul>
          <li><strong>companyId</strong>: The unique identifier for the company</li>
        </ul>

        <h4 style={{ fontSize:'16px',fontWeight: 'bold'}}>Optional Query Parameters</h4>
        <ul>
          <li><strong>limit</strong>: Returns Insight Events filtered by limit.</li>
          <li><strong>offset</strong>: Offset for pagination.</li>
          <li><strong>expandInsightDetails</strong>: Set to true to include full Insight metadata.</li>
          <li><strong>insightEventId</strong>: Returns a specific Insight Event by ID.</li>
          <li><strong>sort</strong>: Sorts by Insight Event creation date.</li>
          <li><strong>filters</strong>: Object with keys like <code>insightTypes</code> or <code>insightCategoryIds</code>.<br />
            <strong>Example:</strong> 
            <pre style={{backgroundColor: '#f5f5f5', color: '#000', padding: '8px', borderRadius: '4px', fontFamily: 'Consolas, monospace', fontSize: '13px', border: '1px solid #ccc', maxWidth: '500px', whiteSpace: 'pre-wrap', wordBreak: 'break-word'}}>
              {`
{
    "insightCategoryIds": [
        "O6MxmucbedK0uWorCTKYqA",
        "i6AdfEHAhspWmLxT2ietkm"
    ],
    "insightTypes": [
        "PLAN_AHEAD",
        "TAKE_ACTION"
    ]
}
`}
              </pre>
          </li>
        </ul>

        <h4 style={{ marginTop: '30px', fontWeight: 'bold' ,fontSize:'16px'}}>
          API Response Model definitions:
        </h4>
        <pre style={preStyle}>{companyInsightEventResponse}</pre>

        <h4 style={{ marginTop: '30px', fontWeight: 'bold' ,fontSize:'16px'}}>
          Sample API Response (when <code>includeInsightsDetails=false</code>):
        </h4>
        <pre style={preStyle}>{sampleEventResponse}</pre>

        <h4 style={{ marginTop: '30px', fontWeight: 'bold' ,fontSize:'16px'}}>
          Sample API Response (when <code>includeInsightsDetails=true</code>):
        </h4>
        <pre style={preStyle}>{insightDetailsTrue}</pre>
      </div>
    </Collapse>
  )}
    </div>
    
    <div className={this.state.showInsightDetailsAPI ? "opblock-summary-description is-open" : "opblock-summary-description"} id="mineral_embedded2" style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
    <div  onClick={this.toggleInsightDetailsAPI} class="opblock-summary-description">
    <div  style={{ fontSize: '16px', fontWeight:'bold'}}>
       Insights Details (GET)
    <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
      {this.state.showInsightDetailsAPI ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
    </i>        
    </div>
    </div>
          {Collapse && (
            <Collapse isOpened={this.state.showInsightDetailsAPI}>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '35px', marginBottom: '10px' }}>
                
                {/* Base URL heading */}
                <h4 style={{ fontSize:'16px', marginTop: '20px',fontWeight: 'bold', margin: 0, marginRight: '10px' }}>API Call:</h4>
                
                {/* Actual API URL */}
                <code
                    style={{
                    backgroundColor: '#f5f5f5',
                    color: '#000',
                    padding: '8px',
                    borderRadius: '4px',
                    fontFamily: 'Consolas, monospace',
                    fontSize: '14px',
                    border: '1px solid #ccc',
                    maxWidth: '60%',  // Limit the width of the code block
                    whiteSpace: 'nowrap',  // Prevent text from wrapping
                    overflow: 'hidden',   // Hide overflow content
                    textOverflow: 'ellipsis', // Show ellipsis when text overflows
                    }}
                >
                     /v2/mintel/insights/{'{insightId}'}/details
                </code>
                </div>            


              <div className="opblock-body">
                <p>Returns full Insight details metadata for a given insightID.</p>
                <h4 style={{ fontWeight: 'bold' ,fontSize:'16px'}} >Required Path Parameter</h4>
                <ul>
                  <li><strong>insightID</strong>: The unique identifier for the Insight</li>
                </ul>
                 <h4 style={{ marginTop: '30px', fontWeight: 'bold' ,fontSize:'16px' }}>
                  API Response Model definitions: (Insight Details):
                </h4>
                <pre style={preStyle}>{apiResponseDefinitionsInsight}</pre>
                <h4 style={{ marginTop: '30px', fontWeight: 'bold' ,fontSize:'16px' }}>
                  Sample API Response (Insight Details):
                </h4>
                <pre style={preStyle}>{sampleInsightDetail}</pre>
              </div>
            </Collapse>
          )}
        </div>

    <div className={this.state.showAPIErrorCodes ? "opblock-summary-description is-open" : "opblock-summary-description"} style={{ paddingTop: '10px', scrollMarginTop: '80px',marginTop: '35px' }}>
    <div  onClick={this.toogleAPIErrorCode}  class="opblock-summary-description">
    <div  style={{ fontSize: '16px',fontWeight: 'bold'}}>
        Insight API Error Code
    <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
        {this.state.showAPIErrorCodes ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
    </i>        
    </div>
    </div>
    {Collapse && (
        <Collapse isOpened={this.state.showAPIErrorCodes}>
        <div className="opblock-body">                
            <table style={{ width: '100%', borderCollapse: 'collapse',  marginTop: '35px',border: '1px solid #ddd' }}>
            <thead>
                <tr style={{ backgroundColor: '#f4f4f4' }}>
                <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'left' }}>Name</th>
                <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'left' }}>Error Code</th>
                <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'left' }}>Status Code</th>
                <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'left' }}>Retry Recommended</th>
                <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'left' }}>Description</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>REQUEST_PARAM_INVALID</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>1000</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>400</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>🚫</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>This error occurs when one or more parameters in the query string fail to meet the validation criteria.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>REQUIRED_PARAMETER</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>1001</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>400</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>🚫</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>This error occurs when a required parameter is not included in the request.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>UNAUTHORIZED</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>1002</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>403</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>🚫</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>This error occurs when a partner attempts to access a resource or perform an action without proper authentication.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>INVALID_TOKEN</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>1003</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>403</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>🚫</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>This error occurs when the provided authentication token is invalid.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>RESOURCE_ACCESS_DENIED</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>1004</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>403</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>🚫</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>This error occurs when a partner attempts to access a resource or perform an action for which they do not have the necessary permissions.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>INTERNAL_SERVER_ERROR</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>3000</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>500</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>🚫</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>This error occurs when the server encounters an unexpected condition that prevents it from fulfilling the request.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>SERVER_TIME_OUT</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>3001</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>503</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>✅</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>This error occurs when the server takes too long to respond. Retry with incremental delays.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>DATA_NOT_FOUND</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>2000</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>404</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>🚫</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>This error occurs when the requested data does not match the specified criteria in the request.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>NO_DATA_EXISTS</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>2001</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>404</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>🚫</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>This error occurs when no data meets the specified criteria for new data.</td>
                </tr>
            </tbody>
            </table>

            {/* Table for Error Response Fields */}
            <h4 style={{ marginTop: '30px', fontWeight: 'bold' ,fontSize:'16px' }}>
            Error Response Fields:
            </h4>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
            <thead>
                <tr style={{ backgroundColor: '#f4f4f4' }}>
                <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'left' }}>Field Name</th>
                <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'left' }}>Description</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>status</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>The Status Name is a textual representation of the HTTP Status Code.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>code</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>HTTP Status Code, which is a numerical value indicating the outcome of the HTTP request.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>errorCode</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>The Internal Error Code that uniquely identifies a specific type of error.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>message</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>The Internal Error Name is a textual representation of the internal error code.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>exceptionDetails</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>Additional information about the error. Optional.</td>
                </tr>
                <tr>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>timestamp</td>
                <td style={{ padding: '10px', border: '1px solid #ddd' }}>The exact date and time when the error occurred in ISO 8601 format.</td>
                </tr>
            </tbody>
            </table>

            {/* Error Response Examples */}
            <h4 style={{ marginTop: '30px', fontWeight: 'bold' }}>
            Error Response Examples:
            </h4>
            <h5>400:</h5>
            <pre style={preStyle}>
    {`{
"status": "BAD_REQUEST",
"code": 400,
"errorCode": "1000",
"message": "REQUEST_PARAM_INVALID",
"exceptionDetail": "Validation failed for parameter(s) limit",
"timestamp": "2024-10-08T17:07:30.988+0000"
}`}
    </pre>
    <h5>401:</h5>
    <pre style={preStyle}>
    {`{
"error": "Invalid token",
"error_description": "Access token expired: ..."
}`}
    </pre>
    <h5>403:</h5>
    <pre style={preStyle}>
    {`{
"status": "FORBIDDEN",
"code": 403,
"errorCode": "1004",
"message": "RESOURCE_ACCESS_DENIED",
"timestamp": "2024-10-08T17:03:22.895+0000"
}`}
    </pre>
    <h5>404:</h5>
    <pre style={preStyle}>
    {`{
"status": "NOT_FOUND",
"code": 404,
"errorCode": "2000",
"message": "DATA_NOT_FOUND",
"timestamp": "2024-10-08T17:05:33.047+0000"
}`}
    </pre>
    <h5>500:</h5>
    <pre style={preStyle}>
    {`{
"timestamp": "12345667890123",
"status": "500",
"error": "Internal Server Error",
"exception": "java.lang.Exception",
"message": "Invalid path.",
"path": "/v2/mintel"
}`}
                        </pre>
                    </div>
                    </Collapse>
                )}
    </div>

    <div className={ this.state.showEmbeddedWebhookSection ? "opblock-summary-description is-open" : "opblock-summary-description"
    } id="mineral_embedded_webhook" style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
    <div onClick={this.showEmbeddedWebhookSection} className="opblock-summary-description" style={{ cursor: 'pointer' }}>
        <div style={{ fontSize: '16px',fontWeight: 'bold' }}>
        Embedded Compliance Intelligence Insights Webhooks
        <i
            className="material-icons pull-right"
            style={{ fontSize: '16px', cursor: 'pointer' }}
        >
            {this.state.showEmbeddedWebhookSection
            ? 'keyboard_arrow_up'
            : 'keyboard_arrow_down'}
        </i>
        </div>
    </div>

    {Collapse && (
        <Collapse isOpened={this.state.showEmbeddedWebhookSection}>
        <div className="opblock-body" style={{ marginTop: '35px' }}>
            <p>
            Mineral’s Embedded Compliance Intelligence Insights API supports webhooks. You can build a webhook to receive
            real-time Mineral Insights data at a specified URL when an insight event is generated.
            This eliminates the need to continually poll Insights API endpoints to check for new
            events.
            </p>

            <p>
            An Embedded Compliance Intelligence Insights subscription means you will be notified when any company-related
            events occur that generate new Mineral Intelligence insights. Those notifications will
            tell you which companies were affected and provide you with enough information to call
            back to the Embedded Compliance Intelligence Insights API to retrieve all of the event details.
            </p>

            <h4 style={{ fontWeight: 'bold', marginTop: '30px',fontSize:'16px' }}>
            How to create a webhook subscription
            </h4>

            <p>
            Webhook subscriptions are managed in the Mineral platform. A brief description of how to
            configure those subscriptions is shown here, but we encourage you to reach out to your
            account representative for help with this.
            </p>

            <p>
            If you have access to Embedded Compliance Intelligence Insights you will see a menu option on the right side of
            your Company Settings page called Webhook Settings.
            </p>
            <img 
                src="https://s3-us-west-2.amazonaws.com/cdn.trustmineral-staging.com/assets/webhook_insight.png" 
                alt="Webhook Settings Screenshot"
                style={{
                    display: 'block',
                    margin: '20px auto',
                    maxWidth: '30%',  // or set fixed width like '600px'
                    height: 'auto',
                    border: '1px solid #ccc', // optional border
                    borderRadius: '4px', // optional rounding
                    marginTop: '35px',
                    marginBottom: '35px'
                }}/>
            <p style={{ marginTop: '35px' }}>
            Clicking on this option brings up a screen that shows you the two pieces of information you need:
            </p>

            <ul>
            <li>
                <strong>Webhook Callback URL:</strong> the endpoint that the Mineral platform should call when one of the events mentioned above occurs. The content of that call (payload and headers) is detailed below. This value is required in order to receive webhook callbacks.
                <p style={{ marginTop: '5px', marginLeft: '20px' }}>
                <strong>Note:</strong> this endpoint should not require authentication. The service listening at this endpoint can use the Encryption Key to validate calls made to it (see below).
                </p>
            </li>

            <li>
                <strong>Webhook Encryption Key:</strong> this key is used to build the signature header described 
                <a href="#webhookpayload" style={{ color: '#1976d2', textDecoration: 'none', marginLeft: '4px' }}>
                below
                </a>. You can use this value to confirm the validity/provenance of calls to your callback URL. This value is optional; if it is left blank a signature header will not be provided.
            </li>
            </ul>

        <img 
        src="https://s3-us-west-2.amazonaws.com/cdn.trustmineral-staging.com/assets/Test_Webhook_Company.png" 
        alt="Webhook Settings Screenshot"
        style={{
            display: 'block',
            margin: '20px auto',
            maxWidth: '80%',  // or set fixed width like '600px'
            height: 'auto',
            border: '1px solid #ccc', // optional border
            borderRadius: '4px', // optional rounding
            marginTop: '35px',
            marginBottom: '35px'
        }}/>
        <h4 style={{ fontWeight: 'bold' ,fontSize:'16px', marginTop: '35px' }} id='webhookpayload'>
        Once you've created a webhook subscription
        </h4>
        <p>
        Once you've created a webhook, event data will be received at the Callback URL you've specified. Here is the payload that endpoint should expect.
        </p>

<h4 style={{ fontWeight: 'bold' ,fontSize:'16px', marginTop: '30px' }} >
  Sample Payload
</h4>

<pre style={{
  backgroundColor: '#f8f8f8',
  color: '#212121',
  padding: '15px',
  border: '1px solid #ddd',
  borderRadius: '4px',
  fontSize: '14px',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
  fontFamily: 'Consolas, monospace',
  marginTop: '20px',
  maxWidth: '100%',
  overflowX: 'auto'
}}>
{`Headers:
  "host": "b3a0-71-63-150-108.ngrok-free.app",
  "user-agent": "axios/1.7.7",
  "content-length": "435",
  "accept": "application/json, text/plain, */*",
  "accept-encoding": "gzip, compress, deflate, br",
  "content-type": "application/json; charset=utf-8",
  "x-forwarded-for": "35.160.13.177",
  "x-forwarded-host": "b3a0-71-63-150-108.ngrok-free.app",
  "x-forwarded-proto": "https",
  "x-mineral-signature": "wAqVEdFE8njMY2yF6+5vZZlboODw1Fn2n2K/zl/y2tg=",
  "x-mineral-timestamp": "1730830574",
  "x-mineral-uuid": "aff51b6fff2c43f88458520a23accb82be"

{
   "specversion":"1.0",
   "type":"company.insights.created",
   "id":"256bd339dc08430baa342772a0dc609f",
   "source":"mintel",
   "data":{
      "partner_id":"2805575",
      "event":{
         "source_specversion":"1.0",
         "company_ids":[
            2805579
         ],
         "resource_ids":[
            "2805579"
         ],
         "resource_type":"company",
         "additional_data":{
            "resources":[
               {
                  "id":"2805579",
                  "Url":"https://restapis.alpha01.trustmineral-staging.com/v2/mintel/2805579/insight-events/"
               }
            ]
         },
         "timestamp":"2026-04-10T06:23:46.088791369"
      }
   }
}
`}
</pre>

    <h4 style={{ fontWeight: 'bold' ,fontSize:'16px', marginTop: '30px' }}>
    Important Headers
    </h4>

    <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
    <li>
        <strong>x-mineral-timestamp</strong>: This is the time the event was published.
        This value is in <strong> <a href="https://www.epochconverter.com/" target="_blank" and rel="noopener noreferrer" style={{ color: '#0073e6', textDecoration: 'underline' }}>seconds since the Unix epoch</a></strong>.
    </li>
    <li>
        <strong>x-mineral-uuid</strong>: is a unique identifier for this event. This value allows you to de-duplicate events in your subscription code as an additional safety measure (Mineral’s Embedded Compliance Intelligence Insights API also guards against delivering duplicate events).
    </li>
    <li>
        <strong>x-mineral-signature</strong>:  is an  <strong> <a href="https://www.okta.com/identity-101/hmac/" target="_blank" and rel="noopener noreferrer" style={{ color: '#0073e6', textDecoration: 'underline' }}>HMAC</a> </strong> value that is built using the Encryption Key (mentioned above, provided in advance). This value allows you to confirm the validity/provenance of calls to your callback URL so you can be sure they came from Mineral.
        <br />
        <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
        <li>
        The value for this header is calculated by using SHA256 with the Encryption Key value to encrypt the <strong>x-mineral-timestamp </strong> value plus the payload, and then Base64 encoding the result. See the <a href="#notes" style={{ color: '#0073e6', textDecoration: 'underline' }}>Notes </a>
         section below for an example of how to reproduce this value in NodeJS. </li>        
        </ul>
    </li>
    </ul>

    <div style={{ marginTop: '30px' }}>
    <h4 style={{ fontWeight: 'bold' ,fontSize:'16px'}}>Payload Attributes</h4>


    <table
    className="parameters"
    style={{ borderCollapse: "collapse", width: "100%", marginTop: "20px" }}
    >
    <thead>
        <tr
        style={{
            backgroundColor: "#e0e0e0",
            color: "black",
            fontWeight: "bold",
            textAlign: "left",
        }}
        >
        <th style={{ padding: "10px", border: "1px solid #ddd" }}>Attribute Name</th>
        <th style={{ padding: "10px", border: "1px solid #ddd" }}>Attribute Type</th>
        <th style={{ padding: "10px", border: "1px solid #ddd" }}>Example Value</th>
        <th style={{ padding: "10px", border: "1px solid #ddd" }}>Notes</th>
        </tr>
    </thead>
    <tbody>
        {payloadAttributes.map((row, i) => (
        <tr
            key={i}
            style={i % 2 === 0 ? {} : { backgroundColor: "#f9f9f9" }}
        >
            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{row.name}</td>
            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{row.type}</td>
            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{row.example}</td>
            <td style={{ padding: "10px", border: "1px solid #ddd" }}>{row.notes}</td>
        </tr>
        ))}
    </tbody>
    </table>

    </div>
    <h4 style={{ fontWeight: 'bold' ,fontSize:'16px',marginTop:'30px',marginBottom: '10px'}}>How to retrieve event details </h4>
    <p style={{ marginTop: 0 }}>
     To retrieve every insight relevant for the given event, simply make a GET call to the endpoints listed under <strong>data.additonal_data.resources </strong>. That endpoint is described in detail in the <a href="#mineralEmbedded"> Mineral Embedded Compliance Intelligence Insights API documentation.</a>
    </p>
    

    <h4 style ={{fontWeight: 'bold' ,fontSize:'16px',marginTop:'30px',marginBottom: '10px'}} id="notes">How to delete a webhook subscription</h4>
    <p style={{ marginTop: 0 }}>
     Please work with your account representative if you wish to disable your Embedded Compliance Intelligence Insights webhook subscriptions.   
    </p>
    </div>
    
    <h4 style={{ fontWeight: 'bold' ,fontSize:'16px',marginTop:'30px',marginBottom: '10px'}} >Notes</h4>
    <p style={{ marginTop: 0 }}>
    Here is an example of using the NodeJS repl to confirm the validity of an event. Note that <strong>glaz_secret_key </strong> is the value of the Encryption Key field provided when configuring your webhook subscription. If this value is not provided, the <strong>x-mineral-signature</strong> header  will not be present.    
    </p>    
    
    <pre style={{
    backgroundColor: '#f8f8f8',
    color: '#212121',
    padding: '15px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    fontFamily: 'Consolas, monospace',
    marginTop: '20px',
    maxWidth: '100%',
    overflowX: 'auto',
    fontWeight: 'bold' // <-- This makes the code bold
    }}>    
    <code>{`// this is the event I received
    -------------- New Request --------------
    Headers:{
    "host": "b3a0-71-63-150-108.ngrok-free.app",
    "user-agent": "axios/1.7.7",
    "content-length": "435",
    "accept": "application/json, text/plain, */*",
    "accept-encoding": "gzip, compress, deflate, br",
    "content-type": "application/json; charset=utf-8",
    "x-forwarded-for": "35.160.13.177",
    "x-forwarded-host": "b3a0-71-63-150-108.ngrok-free.app",
    "x-forwarded-proto": "https",
    "x-mineral-signature": "wAqVEdFE8njMY2yF6+5vZZlboODw1Fn2n2K/zl/y2tg=",
    "x-mineral-timestamp": "1730830574",
    "x-mineral-uuid": "aff51b6fff2c43f88458520a23accb82be"
    }
    Body:{
    "data": {
   "specversion":"1.0",
   "type":"company.insights.created",
   "id":"256bd339dc08430baa342772a0dc609f",
   "source":"mintel",
   "data":{
      "partner_id":"2805575",
      "event":{
         "source_specversion":"1.0",
         "company_ids":[
            2805579
         ],
         "resource_ids":[
            "2805579"
         ],
         "resource_type":"company",
         "additional_data":{
            "resources":[
               {
                  "id":"2805579",
                  "Url":"https://restapis.alpha01.trustmineral-staging.com/v2/mintel/2805579/insight-events/"
               }
            ]
         },
         "timestamp":"2026-04-10T06:23:46.088791369"
      }
   }
  }`}</code>
    </pre>

        </Collapse>
    )}
    
    </div>


    </div>
      </div>
      </span>
    );
  }
}

const tableHeaderStyle = {
  padding: '10px',
  border: '1px solid #ccc',
  maxWidth: '20%',
  minWidth: '6em',
};

const tdStyle = {
  padding: '10px',
  border: '1px solid #ccc',
  color: '#363636',
  fontSize: '16px',
  maxWidth: '20%',
  minWidth: '6em',
  verticalAlign: 'top',
};

const codeStyle = {
  fontSize: '1.05em',
  backgroundColor: '#7e5858ff',
  padding: '4px 8px',
  borderRadius: '5px',
  color: '#333',
};

const preStyle = {
      backgroundColor: '#f8f8f8',
  color: '#000',
  padding: '16px',
  borderRadius: '6px',
  overflowX: 'auto',
  fontFamily: 'Consolas, monospace',
  fontSize: '13px',
  border: '1px solid #ccc',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word'
};

const tableData = [
  {
    name: 'limit',
    type: 'Integer',
    required: 'No',
    filterable: 'No',
    description: 'Returns Insight events filtered by “limit”. Default: 20, Max: 50. Example: limit=10',
  },
  {
    name: 'offset',
    type: 'Integer',
    required: 'No',
    filterable: 'No',
    description: 'Returns Insight events filtered by “offset”. Default: 0. Example: offset=0',
  },
  {
    name: 'sort',
    type: 'String',
    required: 'No',
    filterable: 'No',
    description: 'Returns Insight Events for a given company sorted by insight event created date.<br>Default: "-insightEventCreatedAt". Example: sort="+insightEventCreatedAt"',
  },
  {
    name: 'expandInsightDetails',
    type: 'Boolean',
    required: 'No',
    filterable: 'No',
    description: 'Returns Insight Events with full Insight details metadata when true.<br>Default: false. Example: expandInsightDetails=true',
  },
  {
    name: 'insightEventId',
    type: 'String',
    required: 'No',
    filterable: 'Yes',
    description: 'Returns Insight Events that match the given insightEventId. Example: insightEventId=abc-123',
  },
{
  name: 'filters',
  type: 'JSON',
  required: 'No',
  filterable: 'Yes',
  description: `Returns Insight Events query results filtered by filters criteria provided.<br>
    <strong>Example:</strong>
    <pre style="background-color: #f5f5f5; color: #000; padding: 8px; border-radius: 4px; font-family: Consolas, monospace; font-size: 13px; border: 1px solid #ccc; max-width: 500px; white-space: pre-wrap; word-break: break-word;">
filters: 
{
    "insightCategoryIds": [
        "O6MxmucbedK0uWorCTKYqA",
        "i6AdfEHAhspWmLxT2ietkm"
    ],
    "insightTypes": [
        "PLAN_AHEAD",
        "TAKE_ACTION"
    ]
}
    </pre>
    <strong>Default:</strong> N/A<br>
    <strong>Max:</strong> 5 values in each filter parameter<br>
    <strong>Supported filter parameters:</strong>
    <ul>
      <li>insightCategoryIds</li>
      <li>insightTypes</li>
    </ul>`,
},

{
  name: 'Content-Type',
  type: 'String',
  required: 'No',
  filterable: 'No',
  description: `Default Content-Type.<br>
    <strong>Example:</strong> <code>application/json</code>`,
},
{
  name: 'If-Modified-Since',
  type: 'String',
  required: 'No',
  filterable: 'No',
  description: `It’s an optional header with a Date &amp; time stamp value in UTC.<br>
    This value should be sent <strong>ONLY</strong> if retrieving latest insight events since provided Date &amp; Time.<br>
    <strong>Example:</strong> <code>Tue, 20 Aug 2024 10:35:20 GMT</code>`,
},
{
  name: 'Last-Modified',
  type: 'String',
  required: 'No',
  filterable: 'No',
  description: `Latest Insight Event created, this value should be tracked on the client side, so that the client can use them in subsequent If-Modified-Since requests.<br>
    <strong>Example:</strong> <code>Tue, 21 Aug 2024 10:00:00 GMT</code>`,
},

];

const sampleEventResponse = `{
  "requestReferenceId": "7e7a5702-4944-4f9c-9dfd-01054218a88b",
  "status": "OK",
  "code": "200",
  "limit": "1",
  "offset": "0",
  "sort": "-insightEventCreatedAt",
  "totalRecords": "1",
  "partnerName": "HR Partner Inc",
  "companyName": "HR Company Inc.",
  "companyId": 67456,
  "insightEvents": [
    {
      "insightEventId": "832yiuw23y8eouw238hioqd",
      "insightEventCreatedAt": 1691268370548,
      "insightEventType": "ON_BOARDING",
      "totalEmployeeCount": 48,
      "totalInsights": 3,
      "insights": [
        {
          "insightId": "RJcIgll1y4iAMJNMr6KOx",
          "insightType": "PLAN_AHEAD"
        },
        {
          "insightId": "2lIiABIxdizZgKGKgPC38s",
          "insightType": "TAKE_ACTION"
        },
        {
          "insightId": "2qMEhSTOFtO1qK9HXYcyHU",
          "insightType": "TAKE_ACTION"
        }
      ]
    }
  ]
}`;

const apiResponseDefinitionsInsight = `{
  "requestReferenceId": {
    "type": "string",
    "description": "Unique request identifier.",
    "example": "abcd1234-e5f6-7f8e-9d0c-1234ba56abcd"
  },
  
  "status": {
    "type": "string",
    "description": "HTTP Status.",
    "example": "Ok"
  },

  "code": {
    "type": "string",
    "description": "HTTP Status Code.",
    "example": "200"
  },

  "insights": {
    "type": "array",
    "description": "List of insights returned for the request.",
    "items": {
      "insightId": {
        "type": "string",
        "description": "Unique insight identifier.",
        "example": "RJcIgll1y4iAMJNMr6KOx"
      },
      
      "title": {
        "type": "string",
        "description": "Name of insight.",
        "example": "Mini-COBRA"
      },
      
      "description": {
        "type": "string",
        "description": "Formatted description of the insight.",
        "example": "California mini-COBRA (Cal-COBRA) applies to employers with 20 or more employees and to an employee who has exhausted their 18 months of federal COBRA benefits. Continuation coverage cannot exceed 36 months of coverage under both state and federal COBRA laws."
      },
      
      "jurisdictionType": {
        "type": "string",
        "description": "Jurisdiction of the insight.",
        "example": "STATE",
        "enum": ["FEDERAL", "STATE"]
      },
      
      "jurisdictionName": {
        "type": "string",
        "description": "State or region the insight applies to.",
        "example": "California"
      },
      
      "criteria": {
        "type": "string",
        "description": "Employee count criteria applicable for the insight.",
        "example": "20 Or More Employees"
      },

      "jurisdictionCriteria": {
        "type": "string",
        "description": "Indicates if the insight applies at total or jurisdiction-specific employee count.",
        "example": "TOTAL_EMPLOYEE_COUNT",
        "enum": ["TOTAL_EMPLOYEE_COUNT", "JURISDICTION_EMPLOYEE_COUNT"]
      },
      
      "insightCategories": {
        "type": "array",
        "description": "Categories that the insight belongs to.",
        "items": {
          "id": {
            "type": "string",
            "description": "Unique category identifier.",
            "example": "21vYdVasdfa928388R0niSScySU"
          },
          "name": {
            "type": "string",
            "description": "Name of the category.",
            "example": "Benefits"
          }
        }
      },
      
      "updatedAt": {
        "type": "integer",
        "description": "Timestamp indicating when the insight was last updated.",
        "example": 1691268370548
      },

      "actionItems": {
        "type": "array",
        "description": "Action items associated with the insight.",
        "items": {
          "actionItemId": {
            "type": "string",
            "description": "Unique action item identifier.",
            "example": "21vYdVZGKw88R0niSScySU"
          },
          
          "title": {
            "type": "string",
            "description": "Title of the action item.",
            "example": "Update termination packet"
          },
          
          "description": {
            "type": "string",
            "description": "Detailed description of the action item.",
            "example": "Add COBRA notice if you offer coverage"
          },

          "resourceLink": {
            "type": "array",
            "description": "Links associated with the action item.",
            "items": {
              "type": "string",
              "example": "https://apps.trustmineral.com/resources/charts/6zTPOSYuV2AZPIla8Uztd7/details"
            }
          }
        }
      }
    }
  }
}
`
const sampleInsightDetail = `{
  "requestReferenceId": "7e7a5702-4944-4f9c-9dfd-01054218a88b",
  "status": "OK",
  "code": "200",
  "insights": [
    {
      "insightId": "RJcIgll1y4iAMJNMr6KOx",
      "title": "ACA",
      "description": "The ACA requires employers with 50+ full-time employees to offer affordable health coverage or pay penalties.",
      "insightType": "PLAN_AHEAD",
      "jurisdictionType": "FEDERAL",
      "criteria": "50 Or More Employees",
      "jurisdictionCriteria": "TOTAL_EMPLOYEE_COUNT",
      "insightCategories": [
        {
          "categoryId": "mK7rTQoGy0XzA6LYV5W3x0",
          "name": "Recordkeeping Requirements"
        },
        {
          "categoryId": "3hhRsq5ghDWeBsdCRfIiM1",
          "name": "Injury & Illness Mgt & Reporting"
        }
      ],
      "actionItems": [
        {
          "actionItemId": "3ZEmZRxpDUM5NKL7sUsB1O",
          "title": "Review ACA requirements",
          "description": "Read the *Employer Guide to ACA Play or Pay Rules* to understand your obligations."
        },
        {
          "actionItemId": "1KwFDO8TCJSl54tv7Cy15R",
          "title": "Monitor headcount",
          "description": "Track the number of full-time equivalent (FTE) workers to determine if play or pay rules apply."
        },
        {
          "actionItemId": "48HlEI2n5twAunD0YqWebo",
          "title": "Track employee hours",
          "description": "Track employee hours using one of the allowable measurement methods."
        },
        {
          "actionItemId": "7js4TUJV6Xp0TqOHotBxg0",
          "title": "Offer coverage",
          "description": "Ensure affordable coverage is offered to full-time employees."
        }
      ]
    }
  ]
}`;



const insightDetailsTrue = `{
  "requestReferenceId": "7e7a5702-4944-4f9c-9dfd-01054218a88b",
  "status": "OK",
  "code": "200",
  "limit": "1",
  "offset": "0",
  "sort": "-insightEventCreatedAt",
  "totalRecords": "1",
  "partnerName": "HR Partner Inc",
  "companyName": "HR Company Inc.",
  "companyId": 67456,
  "insightEvents": [
    {
      "insightEventId": "832yiuw23y8eouw238hioqd",
      "insightEventCreatedAt": 1691268370548,
      "insightEventType": "ON_BOARDING",
      "totalEmployeeCount": 48,
      "totalInsights": 3,
      "insights": [
        {
          "insightId": "RJcIgll1y4iAMJNMr6KOx",
          "title": "ACA",
          "description": "The Affordable Care Act (ACA) employer shared responsibility provision includes so-called “play or pay” rules for employers with an average of 50 or more full-time-equivalent (FTE) employees. ...",
          "insightType": "PLAN_AHEAD",
          "jurisdictionType": "FEDERAL",
          "criteria": "50 Or More Employees",
          "jurisdictionCriteria": "TOTAL_EMPLOYEE_COUNT",
          "insightCategories": [
            { "categoryId": "mK7rTQoGy0XzA6LYV5W3x0", "name": "Recordkeeping Requirements" },
            { "categoryId": "3hhRsq5ghDWeBsdCRfIiM1", "name": "Injury & Illness Mgt & Reporting" }
          ],
          "actionItems": [
            {
              "actionItemId": "3ZEmZRxpDUM5NKL7sUsB1O",
              "title": "Review ACA requirements",
              "description": "Read the Employer Guide to ACA Play or Pay Rules to understand your obligations under this law"
            }
          ]
        },
        {
          "insightId": "2lIiABIxdizZgKGKgPC38s",
          "title": "Hiring employees in California:",
          "description": "First, let’s review some key action items for California.",
          "insightType": "TAKE_ACTION",
          "jurisdictionType": "STATE",
          "jurisdictionName": "California",
          "criteria": "0 Or More Employees",
          "jurisdictionCriteria": "JURISDICTION_EMPLOYEE_COUNT",
          "insightCategories": [
            { "categoryId": "S9Vlf6Kmnl37y5rMlOc7Tv", "name": "Discrimination and Harassment Protections" }
          ],
          "actionItems": [
            {
              "actionItemId": "76AVW5nlZyC6ztoJscdhNq",
              "title": "Collect California new hire paperwork",
              "description": "Use the California New Hire Toolkit to make sure you have the necessary new hire forms",
              "resourceLink": "https://apps.trustmineral.com/hr-compliance/documents/7CR31szY7cOlo2kL9HV6g2/details"
            }
          ]
        },
        {
          "insightId": "2qMEhSTOFtO1qK9HXYcyHU",
          "title": "Mini-COBRA",
          "description": "California mini-COBRA (Cal-COBRA) applies to employers with 20 or more employees and to an employee who has exhausted their 18 months of federal COBRA benefits. ...",
          "insightType": "TAKE_ACTION",
          "jurisdictionType": "STATE",
          "jurisdictionName": "California",
          "criteria": "20 Or More Employees",
          "jurisdictionCriteria": "TOTAL_EMPLOYEE_COUNT",
          "actionItems": [
            {
              "actionItemId": "21vYdVZGKw88R0niSScySU",
              "title": "Update termination packet",
              "description": "Add COBRA notice if you offer coverage"
            }
          ]
        }
      ]
    }
  ]
}`;


const payloadAttributes = [
  {
    name: "source_specversion",
    type: "string",
    example: '"1.2"',
    notes:
      "A version number for this JSON payload. If the structure of the event payload changes, this value will change as well. Used to help maintain backward compatibility.",
  },
  {
    name: "company_ids",
    type: "array of integers",
    example: "[8798734, 2345678, 8472772]",
    notes: "A list of companies affected by this event.",
  },
  {
    name: "resource_ids",
    type: "array of strings",
    example: '[8798734, 2345678, 8472772]',
    notes: "A list of the resources (e.g. insights) included in this event.",
  },
  {
    name: "resource_type",
    type: "string",
    example: '"company"',
    notes: "The type of object affected by this event.",
  },
  {
    name: "additional_data.resources.id",
    type: "string",
    example: '"987"',
    notes: "An insight id. Also included in the resource URL.",
  },
  {
    name: "additional_data.resources.Url",
    type: "URL",
    example: "https://restapis.trustmineral.com/v2/mintel/987/insight-events/",
    notes: "Use this value to retrieve details about this event (see below).",
  },
  {
    name: "timestamp",
    type: "timestamp in ISO-8601 format",
    example: '"2024-11-05T10:14:00Z"',
    notes:
      "This is the time the event was generated by the Mineral platform, not the time the event was sent to the subscription endpoint.",
  },
];




const companyInsightEventResponse = `{
  "requestReferenceId": {
    "type": "string",
    "description": "Unique request identifier.",
    "example": "abcd1234-e5f6-7f8e-9d0c-1234ba56abcd"
  },

  "status": {
    "type": "string",
    "description": "HTTP Status.",
    "example": "Ok"
  },

  "code": {
    "type": "string",
    "description": "HTTP Status Code.",
    "example": "200"
  },

  "limit": {
    "type": "integer",
    "description": "Maximum number of records returned.",
    "example": 1
  },

  "offset": {
    "type": "integer",
    "description": "Number of records skipped before starting results.",
    "example": 10
  },

  "sort": {
    "type": "string",
    "description": "Sort order of the results, either ascending (+eventCreatedAt) or descending (-eventCreatedAt).",
    "example": "-eventCreatedAt"
  },

  "totalRecords": {
    "type": "string",
    "description": "Total number of records that match the filter criteria.",
    "example": "2"
  },

  "companyName": {
    "type": "string",
    "description": "Name of the company for associated insights.",
    "example": "HR Company Inc"
  },

  "partnerName": {
    "type": "string",
    "description": "Name of the company for associated insights.",
    "example": "HR Partner Inc"
  },

  "companyId": {
    "type": "integer",
    "description": "Company ID for associated insights.",
    "example": 4567890
  },

  "insightEvents": {
    "type": "array",
    "description": "List of insight events returned for the company.",
    "items": {
      "insightEventId": {
        "type": "string",
        "description": "Unique insight event identifier.",
        "example": "832yiuw23y8eouw238hioqd"
      },

      "insightEventCreatedAt": {
        "type": "integer",
        "description": "Insight event creation date in UTC long milliseconds.",
        "example": 1691268370548
      },

      "insightEventType": {
        "type": "string",
        "description": "Insight event creation type.",
        "example": "ON_BOARDING",
        "enum": ["ON_BOARDING", "LOCATION_UPDATE", "CONTENT_UPDATE"]
      },

      "totalEmployeeCount": {
        "type": "integer",
        "description": "Total employee count when current insight event was generated.",
        "example": 120
      },

      "totalInsights": {
        "type": "integer",
        "description": "Total number of insights generated for current insight event.",
        "example": 3
      },

      "insights": {
        "type": "array",
        "description": "List of insights generated for the current event.",
        "items": {
          "insightId": {
            "type": "string",
            "description": "Unique insight identifier.",
            "example": "RJcIgll1y4iAMJNMr6KOx"
          },

          "title": {
            "type": "string",
            "description": "Name of the insight.",
            "example": "Mini-COBRA"
          },

          "description": {
            "type": "string",
            "description": "Formatted description of the insight.",
            "example": "California mini-COBRA (Cal-COBRA) applies to employers with 20 or more employees and to an employee who has exhausted their 18 months of federal COBRA benefits. Continuation coverage cannot exceed 36 months of coverage under both state and federal COBRA laws."
          },

          "insightType": {
            "type": "string",
            "description": "Type of insight.",
            "example": "TAKE_ACTION",
            "enum": ["PLAN_AHEAD", "TAKE_ACTION"]
          },

          "jurisdictionType": {
            "type": "string",
            "description": "Jurisdiction of the insight.",
            "example": "STATE",
            "enum": ["FEDERAL", "STATE"]
          },

          "jurisdictionName": {
            "type": "string",
            "description": "Name of the state for which the insight is applicable.",
            "example": "California"
          },

          "criteria": {
            "type": "string",
            "description": "Employee count criteria applicable for the insight.",
            "example": "20 Or More Employees"
          },

          "jurisdictionCriteria": {
            "type": "string",
            "description": "Indicates if state jurisdiction insight applies at a total or jurisdiction-specific employee count.",
            "example": "TOTAL_EMPLOYEE_COUNT",
            "enum": ["TOTAL_EMPLOYEE_COUNT", "JURISDICTION_EMPLOYEE_COUNT"]
          },

          "insightCategories": {
            "type": "array",
            "description": "Categories that the insight belongs to.",
            "items": {
              "id": {
                "type": "string",
                "description": "Unique category identifier.",
                "example": "21vYdVasdfa928388R0niSScySU"
              },

              "name": {
                "type": "string",
                "description": "Name of the category.",
                "example": "Benefits"
              }
            }
          },

          "actionItems": {
            "type": "array",
            "description": "Action items associated with the insight.",
            "items": {
              "actionItemId": {
                "type": "string",
                "description": "Unique action item identifier.",
                "example": "21vYdVZGKw88R0niSScySU"
              },

              "title": {
                "type": "string",
                "description": "Title of the action item.",
                "example": "Update termination packet"
              },

              "description": {
                "type": "string",
                "description": "Detailed description of the action item.",
                "example": "Add COBRA notice if you offer coverage"
              },

              "resourceLink": {
                "type": "array",
                "description": "Links associated with the action item.",
                "items": {
                  "type": "string",
                  "example": "https://apps.trustmineral.com/resources/charts/6zTPOSYuV2AZPIla8Uztd7/details"
                }
              }
            }
          }
        }
      }
    }
  }
}`;

export default MineralEmbedded;



// WEBPACK FOOTER //
// ./src/plugins/thinkhr/mineral-embedded.jsx